import { assessmentChange, lccstore, studyPlanToolChange, userstore } from '@holmescorp/lcc-state';
import { logSystem } from '@holmescorp/logger';
import { svc } from './svc';
export const calculatePlan = async (studyTrack, scores, tgf_recommendations = 3) => {
    logSystem.info(() => `begin: calculatePlan(${studyTrack}, ${JSON.stringify(scores)}, ${tgf_recommendations})`);
    studyPlanToolChange({ ml: { inFlight: true } });
    const recommendations = await svc.recommended_study_plan({
        studyTrack,
        scores,
        tgf_recommendations
    });
    if ('error' in recommendations && recommendations.error) {
        studyPlanToolChange({ ml: { inFlight: false } });
        logSystem.info(() => `error :: calculatePlan: ${JSON.stringify(recommendations)}`);
    }
    else {
        studyPlanToolChange({ ml: { inFlight: false } });
        assessmentChange({ assessment: recommendations });
        logSystem.info(() => `finished :: calculatePlan: ${JSON.stringify(recommendations)}`);
    }
};
export const mayTriggerML = async (force = false) => {
    const { path } = userstore;
    const { value: sp } = path('toolstate', 'studyplan');
    const { value: quizPattern } = path('quizPattern');
    const { useML = false, ml = {
        inFlight: false,
        recommendations: false,
        completedOnce: false
    } } = sp;
    if (useML) {
        const { value: nls } = lccstore.path('dynls');
        const { messages } = nls.get('ditabook') || {};
        const flag = messages?.recommended_to_flag || '3';
        const { recommendations = false, completedOnce = false } = ml;
        if (force || !recommendations || !completedOnce) {
            const tgf_recommendations = parseInt(flag);
            const scores = path('assessment').value || {};
            await calculatePlan(quizPattern, scores, tgf_recommendations);
            return true;
        }
    }
    return false;
};
export default mayTriggerML;
